module.exports = __webpack_public_path__ + "static/media/24951A53-32ED-4D54-AB12-D9611476AD8B.94fefec6.jpeg";